import React from "react"
import {Button, Form, Input} from "antd"
import {MappingFormItem} from "./MappingFormItem"
import {LDAPServerInfo, MapperType, TypeSafeMapper} from "../../../models/ldap-server-info"

type Mapping = {
  type: string
  value: string
}

type FormLDAPServerInfo = {
  name: string
  queryTemplate: string
  mapping: {
    email: Mapping
    employeeId: Mapping
    fullName: Mapping
    title: Mapping
  }
}

type Props = {
  onSubmit: (ldapServerInfo: LDAPServerInfo) => void
}

export const EditLDAPForm: React.FC<Props> = ({
  onSubmit
}): React.ReactElement => {
  const [form] = Form.useForm<FormLDAPServerInfo>()

  const mapMapping = (mapping: Mapping): TypeSafeMapper => {
    const { type, value } = mapping
    return {
      type: type === "constant" ? MapperType.Constant : MapperType.Field,
      value
    }
  }
  const onFormSubmit = (ldapServerInfo: FormLDAPServerInfo) => {
    const mappedLdapServerInfo: LDAPServerInfo = {
      name: ldapServerInfo.name,
      queryTemplate: ldapServerInfo.queryTemplate,
      userInfoMapper: {
        employeeId: mapMapping(ldapServerInfo.mapping.employeeId),
        fullName: mapMapping(ldapServerInfo.mapping.fullName),
        email: mapMapping(ldapServerInfo.mapping.email),
        title: mapMapping(ldapServerInfo.mapping.title),
      }
    }
    onSubmit(mappedLdapServerInfo)
  }

  const onQueryTemplateChanged = () => {
    const queryTemplate = form.getFieldValue("queryTemplate")
    try {
      const formattedJsonString = JSON.stringify(JSON.parse(queryTemplate), null, 2)
      form.setFieldValue("queryTemplate", formattedJsonString)
    } catch (e) { /**/ }
  }
  return <Form
    form={form}
    onFinish={onFormSubmit}
    labelCol={{ span: 4 }}
  >
    <Form.Item
      name="name"
      label="Name"
      rules={[
        { required: true, message: "LDAP Server name is required" }
      ]}>
      <Input/>
    </Form.Item>

    <Form.Item
      name="queryTemplate"
      label="Query Template"
      rules={[
        { validator: async (_, value) => {
          try {
            JSON.parse(value)
            return
          } catch (e) {
            console.log("validation failed")
            throw new Error("Incorrect json format")
          }
        }}
      ]}>
      <Input.TextArea onChange={onQueryTemplateChanged}/>
    </Form.Item>

    <MappingFormItem label="Employee Id" name={["mapping", "employeeId"]} required/>
    <MappingFormItem label="Email" name={["mapping", "email"]} required/>
    <MappingFormItem label="Title" name={["mapping", "title"]} required/>
    <MappingFormItem label="Full name" name={["mapping", "fullName"]} required/>

    <Form.Item
      wrapperCol={{ offset: 8, span: 16 }}
    >
      <Button type="primary" htmlType="submit">
        Create
      </Button>
    </Form.Item>

  </Form>
}